// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg display="none" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <symbol id="svg-plus" viewBox="0 0 50 50">
                <title>plus</title>
                <path d="M50 22H28V0h-6v22H0v6h22v22h6V28h22"/>
            </symbol>
        </defs>
    </svg>
`
};

export const IconPlus = () => <span dangerouslySetInnerHTML={icon} />;

export default IconPlus;
